import { render } from "./SerialNumberDefault.vue?vue&type=template&id=45f7b828"
import script from "./SerialNumberDefault.vue?vue&type=script&lang=js"
export * from "./SerialNumberDefault.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__